export interface BuildGradientStyle {
    backgroundColor?: string
    backgroundImage?: string
}

export type GradientStyleDirection = '180deg' | '90deg' | 'to right' | 'to bottom' | 'radial'

export const buildGradientStyle = (
    colors?: string[],
    direction: GradientStyleDirection = 'to right'
): BuildGradientStyle => {
    const fallbackColors = ['#FFFFFF']
    const appliedColors = colors && colors.length > 0 ? colors : fallbackColors

    if (appliedColors.length === 1) {
        return { backgroundColor: appliedColors[0] }
    } else if (appliedColors.length > 1) {
        return direction !== 'radial'
            ? { backgroundImage: `linear-gradient(${direction}, ${appliedColors.join(', ')})` }
            : { backgroundImage: `radial-gradient(${appliedColors.join(', ')})` }
    }

    return { backgroundColor: 'transparent' }
}
